<template>
  <BaseDialog :is-open="isOpen" @close="emit('close')">
    <form
      class="flex flex-col gap-4 px-2 py-4"
      @submit="onFormSubmit"
    >
      <FormInputText name="email" label="Email Address" />
      <FormSubmitButton :is-submitting="isSubmitting"
        >Send Receipt</FormSubmitButton
      >
    </form>
  </BaseDialog>
</template>

<script setup lang="ts">
import z from "zod"
import { useForm } from "vee-validate"
import { toTypedSchema } from "@vee-validate/zod"

const props = defineProps<{
  isOpen: boolean
  orderId?: string
  donationId?: string
}>()

const emit = defineEmits<{
  (event: "close"): void
}>()

const formSchema = z.object({
  email: z
    .string()
    .email("Please enter a valid email address")
    .min(1, "Please enter a valid email address"),
})

const { handleSubmit, isSubmitting } = useForm({
  validationSchema: toTypedSchema(formSchema),
  initialValues: { email: "" },
})

const onFormSubmit = handleSubmit(async (formValues) => {
  try {
    if (props.orderId) {
      await sendOrderReceipt(props.orderId, formValues)
    } else if (props.donationId) {
      await sendDonationReceipt(
        props.donationId,
        formValues
      )
    }

    toast.success(`Receipt sent to ${formValues.email}`)
    emit("close")
  } catch {
    toast.error("Failed to send receipt")
  }
})
</script>
